/**
 * Import Swiper JS
 */

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// DOM Content Loaded
document.addEventListener('DOMContentLoaded', function () {

    /**
     * Swiper to use modules
     * Navigation
     */

    Swiper.use([Navigation, Pagination, Autoplay]);

    /**
     * Header
     */

    if (document.querySelector('.swiper[data-swiper=quote]')) {
        const swiperQuote = new Swiper('.swiper[data-swiper=quote]', {
            loop: true,
            autoHeight: true,
            spaceBetween: '32px',
            slidesPerView: 1,
            navigation: {
                prevEl: '.js-swiper-prev[data-swiper=quote]',
                nextEl: '.js-swiper-next[data-swiper=quote]',
            },
            pagination: {
                el: '.swiper-pagination[data-swiper=quote]',
                clickable: true,
                dynamicBullets: true,
            },
        });
    }

    /**
     * Related
     */

    const swiperRelatedSliders = document.querySelectorAll('.swiper[data-swiper=related]');
    for (const swiperRelatedSlider of swiperRelatedSliders) {
        const swiperRelated = new Swiper(swiperRelatedSlider, {
            loop: true,
            autoHeight: true,
            spaceBetween: '32px',
            slidesPerView: 1,
            navigation: {
                prevEl: swiperRelatedSlider.closest('.related-slider').querySelector('.js-swiper-prev[data-swiper=related]'),
                nextEl: swiperRelatedSlider.closest('.related-slider').querySelector('.js-swiper-next[data-swiper=related]'),
            },
            pagination: {
                el: swiperRelatedSlider.querySelector('.swiper-pagination[data-swiper=related]'),
                clickable: true,
                dynamicBullets: true,
            },
            breakpoints: {
                // Tablet small
                601: {
                    spaceBetween: '20px',
                    slidesPerView: 2,
                },
                // Tablet large
                801: {
                    spaceBetween: '32px',
                    slidesPerView: 3,
                }
            }
        });
    }

    /**
     * Image slider
     */

    const imgSliderSliders = document.querySelectorAll('.swiper[data-swiper=img-slider]');
    for (const imgSliderSlider of imgSliderSliders) {
        const imgSlider = new Swiper(imgSliderSlider, {
            loop: true,
            autoHeight: false,
            spaceBetween: '20px',
            slidesPerView: 'auto',
            centeredSlides: true,
            pagination: {
                el: imgSliderSlider.querySelector('.swiper-pagination[data-swiper=img-slider]'),
                clickable: true,
                dynamicBullets: true,
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: true,
            },
            breakpoints: {
                // Tablet small
                601: {
                    spaceBetween: '40px',
                },
                // Tablet large
                801: {
                    spaceBetween: '60px',
                },
                // desktop small
                1101: {
                    spaceBetween: '80px',
                }
            }
        });
    }

});
